<template>
  <li class="coming-webinars__item">
    <a :is="tag" :href="`/${lang}/webinars/${filePath}/`" class="coming-webinars__link-card" target="_self">
      <div class="coming-webinars__date-col coming-webinars__col">
        <div class="coming-webinars__date">{{ dateExpire }}</div>
        <div class="coming-webinars__time"> Начинаем в {{ time }}</div>
      </div>
      <div class="coming-webinars__about coming-webinars__col">
        <div v-if="badge !== ''" class="coming-webinars__badge">{{ badge }}</div>
        <div class="coming-webinars__title"><span v-html="title"></span></div>
        <div class="coming-webinars__description">
          <span v-html="description"></span>
        </div>
      </div>
      <div class="coming-webinars__speakers coming-webinars__col">
        <div
          class="coming-webinars__speaker-item"
          v-for="speaker in speakers"
        >
          <div class="coming-webinars__speaker-photo">
            <picture>
              <source :srcset="`/${lang}/${speaker.avatar}.webp`" type="image/webp">
              <source :srcset="`/${lang}/${speaker.avatar}.jpg`" type="image/jpg">
              <img :src="`/${lang}/${speaker.avatar}.png`" :alt="speaker.name">
            </picture>
          </div>
          <div class="coming-webinars__speaker-about">
            <div class="coming-webinars__speaker-name">{{ speaker.name }}</div>
            <div class="coming-webinars__speaker-position"><span v-html="speaker.job"></span></div>
          </div>
        </div>
      </div>
      <div class="coming-webinars__link coming-webinars__col">
        <span v-if="soon">Регистрация скоро откроется</span>
        <span v-else class="link-arrow">{{ coming ? 'Смотреть' : 'Записаться' }}</span>
      </div>
    </a>
  </li>
</template>

<script>
export default {
  name: "WebinarRuCard",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    dateExpire: {
      type: String,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    filePath: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      required: true
    },
    speakers: {
      type: Array,
      required: true
    },
    coming: Boolean,
    soon: {
      type: Boolean,
      default: false
    },
    badge: String
  },
  data () {
    return {
      tag: this.soon ? 'div' : 'a'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/WebinarRuCard.vue